/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */

'use strict';

function RelayDefaultHandlerProvider(handle) {
  switch (handle) {
    case 'connection':
      return require('./RelayConnectionHandler');
    case 'viewer':
      return require('./RelayViewerHandler');
  }
  !false ? process.env.NODE_ENV !== 'production' ? require('fbjs/lib/invariant')(false, 'RelayDefaultHandlerProvider: No handler provided for `%s`.', handle) : require('fbjs/lib/invariant')(false) : void 0;
}

module.exports = RelayDefaultHandlerProvider;


//////////////////
// WEBPACK FOOTER
// ./~/relay-runtime/lib/RelayDefaultHandlerProvider.js
// module id = 2589
// module chunks = 3